module.exports = __webpack_public_path__ + "68c47a8fadfa143359b78a77a5f308c0.svg";